import { Component } from '@angular/core';
import { ThemeService, ThemeMode } from '@app/core/services/theme.service';
import { AccessibilityService, ColorBlindMode } from '@app/core/services/accessibility.service';
import { NotificationService } from '@app/core/services/notification.service';

/**
 * Modal de configurações da aplicação
 * Permite ao usuário personalizar tema e acessibilidade
 */
@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html'
})
export class SettingsModalComponent {
  isOpen = false;
  showConfirmModal = false;
  currentTheme: ThemeMode = 'system';
  currentColorBlindMode: ColorBlindMode = 'none';
  
  themeOptions: Array<{ value: ThemeMode; label: string; icon: string; description: string }> = [
    {
      value: 'light',
      label: 'Claro',
      icon: 'sun',
      description: 'Tema claro para ambientes bem iluminados'
    },
    {
      value: 'dark',
      label: 'Escuro',
      icon: 'moon',
      description: 'Tema escuro para reduzir cansaço visual'
    },
    {
      value: 'system',
      label: 'Sistema',
      icon: 'monitor',
      description: 'Seguir preferência do sistema operacional'
    }
  ];

  get colorBlindOptions() {
    return this.accessibilityService.getAvailableModes();
  }

  constructor(
    private themeService: ThemeService,
    private accessibilityService: AccessibilityService,
    private notificationService: NotificationService
  ) {
    this.currentTheme = this.themeService.getCurrentTheme();
    this.currentColorBlindMode = this.accessibilityService.getCurrentMode();
  }

  open(): void {
    this.isOpen = true;
    // Previne scroll do body com modal aberta
    document.body.style.overflow = 'hidden';
  }

  close(): void {
    this.isOpen = false;
    document.body.style.overflow = '';
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('settings-backdrop')) {
      this.close();
    }
  }

  selectTheme(theme: ThemeMode): void {
    this.currentTheme = theme;
    this.themeService.setTheme(theme);
  }

  selectColorBlindMode(mode: ColorBlindMode): void {
    this.currentColorBlindMode = mode;
    this.accessibilityService.setColorBlindMode(mode);
  }

  isThemeSelected(theme: ThemeMode): boolean {
    return this.currentTheme === theme;
  }

  isColorBlindModeSelected(mode: ColorBlindMode): boolean {
    return this.currentColorBlindMode === mode;
  }

  abrirConfirmacaoRestaurar(): void {
    this.showConfirmModal = true;
  }

  fecharConfirmacao(): void {
    this.showConfirmModal = false;
  }

  /** Padrão: Tema Claro (light) + Acessibilidade Nenhum (none). */
  confirmarRestaurarPadroes(): void {
    this.showConfirmModal = false;
    this.selectTheme('light');
    this.selectColorBlindMode('none');

    // Reaplica tema e remove filtros após o CD do modal fechar, pra garantir efeito visual
    setTimeout(() => {
      this.themeService.setTheme('light');
      this.accessibilityService.forceRemoveFilters();
    }, 100);

    this.notificationService.success({
      title: 'Configurações Restauradas!',
      message: 'Todas as configurações voltaram ao padrão.'
    });
  }
}
